export default {
  title: "Recover password",
  description: "Enter your email to receive a password recovery link",
  emailLabel: "Email",
  submit: "Send recovery link",
  sending: "Sending...",
  backToLogin: "Back to login",
  emailSentTitle: "Email sent!",
  emailSentDescription: "If the email exists in our system, you will receive a link to reset your password",
  sentTo: "Link sent to",
  checkSpam: "Also check your spam folder if you don't find the email in your inbox",
  tryAnotherEmail: "Try another email",
  // Anti-abuse protection
  cooldownMessage: "Wait {{seconds}} seconds to try again",
  rateLimit: "Rate limit exceeded",
  rateLimitDescription: "For security reasons, you must wait before trying again",
  attemptsRemaining: "Attempts remaining: {{attempts}}",
  captchaLabel: "Security verification",
  captchaRequired: "Please complete the security verification",
  tooManyAttempts: "Too many attempts detected"
} as const;
